import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useTimeout } from "../../../common/hooks/use-timeout";
import { Success } from "../feedback-screen/success/success";
import { t } from "i18next";

interface ILoginSuccessPromptProps {
    userName: string;
}

export const LoginSuccessPrompt = (props: ILoginSuccessPromptProps) => {
    const navigate = useNavigate();

    useTimeout(() => navigate("/"), 3500, true);

    return <Success>
        {t("login.success", { userName: props.userName })}
    </Success>;
};
